import { Component } from 'react';
import DataTable from '../../components/Datatable';
import { COLUMNS } from './keys';
import { v4 as uuid } from 'uuid';
import { scrollForTable } from '../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class UserActivities extends Component {
    constructor() {
        super();

        this.searchFunction = this.searchFunction.bind(this);
        this.state = { data: [] };
    }

    componentDidMount() {
        const data = JSON.parse(this.props.user_activities);
        this.setState({
            data: data?.map((x) => ({ ...x, id: uuid(), domain: x.domain ?? '' })),
        });
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter(
            (item) =>
                (item.user && item.user.toLowerCase().includes(search.toLowerCase())) ||
                (item.domain && item.domain.toLowerCase().includes(search.toLowerCase())),
        );
    }

    render() {
        const { t } = this.props;
        if (!JSON.parse(this.props.user_activities)?.[0]) return <div>There is no data.</div>;
        const sortFns = {
            user: (array) => array.sort((a, b) => a.user?.localeCompare(b.user)),
            domain: (array) => array.sort((a, b) => a.domain?.localeCompare(b.domain)),
            pages_count: (array) =>
                array.sort((a, b) => Number(a.pages_count) - Number(b.pages_count)),
            days_count: (array) =>
                array.sort((a, b) => Number(a.days_count) - Number(b.days_count)),
            unique_pages_count: (array) =>
                array.sort((a, b) => Number(a.unique_pages_count) - Number(b.unique_pages_count)),
            created: (array) => array.sort((a, b) => new Date(a.created) - new Date(b.created)),
        };

        return (
            <>
                <DataTable
                    nodes={this.state.data}
                    sortFns={sortFns}
                    searchFunction={this.searchFunction}
                    header={t('user_activities.header')}
                    COLUMNS={COLUMNS(t)}
                    fileName={t('user_activities.header')}
                    additionalStyles={{
                        Table: `
                                --data-table-library_grid-template-columns :  minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                               ${scrollForTable}
                            `,
                        BaseCell: ` font-family: 'Raleway';
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 19px;
                                    padding: 16px 10px !important;
                                    color: #0D182C;
                                
                                
                                    &.underline {
                                        text-decoration: underline;
                                    }
                                    `,
                    }}
                />
            </>
        );
    }
}

export default withTranslation()(UserActivities);
